<!-- 查询高级点位 -->
<template>
  <div class="ServiceMarketQuery">
    <app-breadcrumb/>
    <div class="page-container account">
      <div class="filter">
        <el-form :inline="true" :model="listQuery" size="mini">
          <!-- 期数-->
          <el-form-item :label="$t('common.periods') + ':'">
            <el-select v-model="listQuery.wWeek" placeholder="" style="width: 120px;">
              <el-option v-for="item in wWeekList" :key="item.wWeek" :label="item.wWeek" :value="item.wWeek"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('推荐安置')+':'">
            <el-select size="mini" v-model="listQuery.netType" placeholder="" @change="changenetType" >
              <el-option :label="$t('mi.recommendNo')" value="0"/>
              <el-option :label="$t('mi.linkNo')" value="1"/>
            </el-select>
          </el-form-item>
          <el-button :loading="btnLoading" size="small" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('function.menu.search') }}</el-button>
        </el-form>
        <el-form :inline="true"  size="mini">
          <!-- 编号-->
          <el-form-item :label="$t('miMember.memberNo') + ':'">
            {{listQuery2.memberNo}}
          </el-form-item>
          <!-- 姓名-->
          <el-form-item :label="$t('miMember.name') + ':'">
            {{listQuery2.name}}
          </el-form-item>
          <!--荣衔 -->
          <el-form-item :label="$t('mi.honourLevel') + ':'">
            {{$lt(initDict.cardtype,listQuery2.newCardType)}}
          </el-form-item>
          <!-- -->
          <el-form-item :label="$t('活跃荣衔') + ':'">
            {{$lt(initDict.qhonour,listQuery2.qhonour)}}
          </el-form-item>
        </el-form>
      </div>
      <el-table
          v-if="listQuery.netType ==0"
          v-loading="btnLoading"
          :data="list"
          border
          fit
          size="mini"
          stripe
          style="width: 100%"
      >
        <el-table-column label="操作" width="50" align="center" class-name="small-padding fixed-width">
          <template slot-scope="{row}">
            <el-button :loading="btnLoading" title="查看" icon="el-icon-search" circle @click="handleView(row)" />
          </template>
        </el-table-column>
        <!--        期次-->
        <el-table-column :label="$t('common.periods')" prop="wWeek" align="center"/>
        <!--       推荐人编号 -->
<!--        <el-table-column :label="$t('mi.recommendNo')" prop="recommendNo" align="center"/>-->
        <el-table-column :label="$t('miMemberNetwork.memberNo')" prop="memberNo" align="center"/>
        <!--    姓名    -->
        <el-table-column :label="$t('miMember.name')" prop="name" align="center"/>
        <!--        活跃七星数量-->
        <el-table-column :sortable="true" :label="$t('活跃七星数量')" prop="qsevenstarnum2" align="center">
          <template slot-scope="{row}">
            <span style="color: red" v-if="Number(row.qsevenstarnum2) > 0">{{row.qsevenstarnum2}}</span>
            <span  v-else>{{row.qsevenstarnum2}}</span>
          </template>
        </el-table-column>
        <!--        活跃一星数量-->
        <el-table-column :sortable="true"  :label="$t('活跃一星数量')" prop="qstarnum2" align="center">
          <template slot-scope="{row}">
            <span style="color: red" v-if="Number(row.qstarnum2) > 0">{{row.qstarnum2}}</span>
            <span  v-else>{{row.qstarnum2}}</span>
          </template>
        </el-table-column>
        <!--        活跃钻石数量-->
        <el-table-column :sortable="true"  :label="$t('活跃钻石数量')" prop="qdiamondnum2" align="center">
          <template slot-scope="{row}">
            <span style="color: red" v-if="Number(row.qdiamondnum2) > 0">{{row.qdiamondnum2}}</span>
            <span  v-else>{{row.qdiamondnum2}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-table
          v-if="listQuery.netType ==1"
          v-loading="btnLoading"
          :data="list"
          border
          fit
          size="mini"
          stripe
          style="width: 100%"
      >
        <el-table-column label="操作" width="50" align="center" class-name="small-padding fixed-width">
          <template slot-scope="{row}">
            <el-button :loading="btnLoading" title="查看" icon="el-icon-search" circle @click="handleView(row)" />
          </template>
        </el-table-column>
        <!--        期次-->
        <el-table-column :label="$t('common.periods')" prop="wWeek" align="center"/>
        <!--     安置人编号   -->
<!--        <el-table-column  :label="$t('mi.linkNo')" prop="recommendNo" align="center"/>-->
        <el-table-column :label="$t('miMemberNetwork.memberNo')" prop="memberNo" align="center"/>
        <!--    姓名    -->
        <el-table-column :label="$t('miMember.name')" prop="name" align="center"/>
        <!--        活跃七星数量-->
        <el-table-column :sortable="true"  :label="$t('活跃七星数量')" prop="qsevenstarnum" align="center">
          <template slot-scope="{row}">
            <span style="color: red" v-if="Number(row.qsevenstarnum) > 0">{{row.qsevenstarnum}}</span>
            <span  v-else>{{row.qsevenstarnum}}</span>
          </template>
        </el-table-column>
        <!--        活跃一星数量-->
        <el-table-column :sortable="true" :label="$t('活跃一星数量')" prop="qstarnum" align="center">
          <template slot-scope="{row}">
            <span style="color: red" v-if="Number(row.qstarnum) > 0">{{row.qstarnum}}</span>
            <span  v-else>{{row.qstarnum}}</span>
          </template>
        </el-table-column>
        <!--        活跃钻石数量-->
        <el-table-column :sortable="true"  :label="$t('活跃钻石数量')" prop="qdiamondnum" align="center">
          <template slot-scope="{row}">
            <span style="color: red" v-if="Number(row.qdiamondnum) > 0">{{row.qdiamondnum}}</span>
            <span  v-else>{{row.qdiamondnum}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
          v-loading="btnLoading"
          :title="$t('')"
          :visible.sync="dcNoBuledialong"
          width="40%"
      >
        <div>
          <el-form>
            <el-form-item :label="$t('miMemberNetwork.memberNo') + ':'">
              {{listQuery1.memberNo}}
            </el-form-item>
            <el-form-item :label="$t('miMember.name') + ':'">
              {{listQuery1.name}}
            </el-form-item>
            <el-form-item :label="$t('钻石数量') + ':'">
              {{listQuery1.zsNum}}
            </el-form-item>
            <el-form-item :label="$t('1星数量') + ':'">
              {{listQuery1.oneNum}}
            </el-form-item>
            <el-form-item :label="$t('活跃钻石数量') + ':'">
              {{listQuery1.activeZsNum}}
            </el-form-item>
            <el-form-item :label="$t('活跃1星数量') + ':'">
              {{listQuery1.activeOneNum}}
            </el-form-item>
          </el-form>
        </div>
        <!-- 尾部按钮 -->
        <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dcNoBuledialong = false">{{ $t('operation.button.cancel') }}</el-button>
  </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>

import {mapGetters} from "vuex";
import {getMiNetnum, listCardThumbnail} from "@/api/ay-personal-center/personalcenter";
export default {
  name: "QueryAdvancedPoints",
  directives: {},
  components: {},
  props: [],
  data() {
    return {
      dcNoBuledialong:false,
      popoverLoading: false,
      loading: false,
      wWeekLoading:false,
      btnLoading:false,
      wWeekList:[],
      list:[],
      listQuery2:{},
      listQuery1:{},
      listQuery:{
        netType:'0'
      },
      initDict:{
        cardtype:'cn.mimember.cardtype',
        qhonour:'active.honors'
      }
    }
  },
  computed: {
    ...mapGetters([
      'isAgent',
      'language',
    ]),
  },
  mounted() {
    this.wWeekList = JSON.parse(sessionStorage.getItem('wWeekLocalList'))
    this.listQuery.wWeek = this.wWeekList[0].wWeek
  },
  methods: {
    getList() {
      this.formLoading = true
      this.btnLoading = true
      listCardThumbnail({ ...this.listQuery}).then(res => {
        this.list = res.data.cardThumbnails
        this.listQuery2 = res.data.cardThumbnailInfo
        this.btnLoading = false
      }).catch(err => {
        console.warn(err)
        this.formLoading = false
        this.btnLoading = false
      })
    },
    handleFilter() {
      this.getList()
    },
    changenetType(){
      this.list = []
    },
    handleView(row){
      getMiNetnum({'netType':this.listQuery.netType,'wWeek':this.listQuery.wWeek,'memberNo':row.memberNo}).then(res=>{
        this.dcNoBuledialong = true
        this.listQuery1 = res.data.cardThumbnailInfo
      })

    }
  }
}
</script>
<style scoped lang="scss">

</style>
